import { InsType } from 'constants/enums/insType.enum';
import { InsTypeName } from 'constants/enums/insTypeName.enum';

/**
 * @description 讓險種類別代碼對應險種類別名稱用
 */
const InsTypeDefines: Readonly<Record<InsType, InsTypeName>> = {
  [InsType.All]: InsTypeName.All,
  [InsType.Travel]: InsTypeName.Travel,
  [InsType.Car]: InsTypeName.Car,
  [InsType.Moto]: InsTypeName.Moto,
  [InsType.Fire]: InsTypeName.Fire,
  [InsType.MobileDevice]: InsTypeName.MobileDevice,
  [InsType.Pet]: InsTypeName.Pet,
  [InsType.ECar]: InsTypeName.ECar,
  [InsType.Emoto]: InsTypeName.Emoto
};

export default InsTypeDefines;
